import React, { useEffect, useState } from "react";
import {
  Modal,
  Button,
  Form,
  Input,
  Select,
  Row,
  Col,
  InputNumber,
  message,
} from "antd";
import configurationManagementService from "@services/configuationManagement.service";
import { isEmpty } from "lodash";

const { Option } = Select;

const CreateAlert = ({ updateDataSource, data = {}, editMode = false }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [changed, setChanged] = useState(false);
  const [operation, setOperation] = useState("");
  const [visible, setVisible] = useState(false);
  const [moes, setMoes] = useState([]);
  const [attributes, setAttributes] = useState([]);
  const [initialValues, setIntialValues] = useState({ vendor: "", mo: "" });

  function showModal() {
    setVisible(true);
  }

  async function handleOk(values) {
    setLoading(true);

    let vals = { ...values };

    if (editMode) vals = { ...data, id: data._id, ...vals };

    if (vals.operation === "between")
      vals.value = Object.values(vals.value).join("-");

    try {
      await configurationManagementService.createAlert(vals);
      setVisible(false);

      setTimeout(() => {
        updateDataSource();
      }, 500);
    } catch (err) {
      message.error("Action has error",20);
      console.log(err);
    } finally {
      setLoading(false);
    }
  }

  function handleCancel() {
    setVisible(false);
  }

  const handleFormValuesChange = async (changedValues) => {
    const formFieldName = Object.keys(changedValues)[0];
    if (formFieldName === "vendor") {
      form.setFieldsValue({ mo: null });
      onChangeVendor(changedValues[formFieldName]);
    } else if (formFieldName === "operation") {
      if (!changed) setChanged(true);
      setOperation(changedValues[formFieldName]);
      form.setFieldsValue({ value: null });
    } else if (formFieldName === "mo") {
      form.setFieldsValue({ parameter: null });
      onChangeMo(form.getFieldValue("vendor"), changedValues[formFieldName]);
    }
  };

  async function onChangeVendor(vendor) {
    setMoes([]);

    try {
      const res = await configurationManagementService.fetchMoList({
        vendor,
      });

      setMoes(
        [...res.data].map((item, i) => (
          <Option key={i.toString(36) + i} value={item}>
            {item}
          </Option>
        ))
      );
    } catch (e) {
      console.log(e);
    }
  }
  async function onChangeMo(vendor, mo) {
    setAttributes([]);
    try {
      const res = await configurationManagementService.fetchAttributeList({
        vendor: vendor,
        mo_name: mo,
      });

      setAttributes(
        [...res.data].map((item, i) => (
          <Option key={i.toString(36) + i} value={item}>
            {item}
          </Option>
        ))
      );
    } catch (e) {
      console.log(e);
    }
  }

  useEffect(() => {
    if (data && !isEmpty(data) && visible) {
      let value = (data.value || "").split("-");

      value =
        data.operation !== "between"
          ? data.value
          : { start: value[0], end: value[1] };

      setTimeout(() => {
        form.setFieldsValue({ ...data, value });
      }, 1000);
    }
    // eslint-disable-next-line
  }, [visible]);

  return (
    <>
      {editMode ? (
        <Button
          onClick={showModal}
          htmlType="button"
          type="text"
          shape="circle"
          size="small"
          className="inline-flex justify-center items-center"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path d="M17.414 2.586a2 2 0 00-2.828 0L7 10.172V13h2.828l7.586-7.586a2 2 0 000-2.828z" />
            <path
              fillRule="evenodd"
              d="M2 6a2 2 0 012-2h4a1 1 0 010 2H4v10h10v-4a1 1 0 112 0v4a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"
              clipRule="evenodd"
            />
          </svg>
        </Button>
      ) : (
        <Button onClick={showModal} htmlType="button" type="primary">
          Create New Alert
        </Button>
      )}

      <Modal
        visible={visible}
        title={editMode ? "Update Alert" : "Create new Alert"}
        onOk={() => form.submit()}
        style={{ maxWidth: "90%" }}
        width={800}
        onCancel={handleCancel}
        footer={[
          <Button key="back" htmlType="button" onClick={handleCancel}>
            Close
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={() => form.submit()}
          >
            Submit
          </Button>,
        ]}
      >
        <Form
          onFinish={handleOk}
          onValuesChange={handleFormValuesChange}
          form={form}
          layout="vertical"
          initialValues={{ enable: true, ...initialValues }}
        >
          <Row gutter={[16, 16]}>
            <Col className="flex-grow flex-shrink-0">
              <Form.Item
                name="vendor"
                label="Vendor"
                rules={[{ required: true }]}
                shouldUpdate={(prev, next) => {
                  if (prev.vendor !== next.vendor) onChangeVendor(next.vendor);
                }}
              >
                <Select
                  className="flex-shrink-0"
                  options={[{ label: "Huawei", value: "huawei" }]}
                />
              </Form.Item>
            </Col>
            <Col className="flex-grow flex-shrink-0">
              <Form.Item
                name="mo"
                label="MO"
                rules={[{ required: true }]}
                shouldUpdate={(prev, next) => {
                  if (prev.mo !== next.mo) onChangeMo(next.vendor, next.mo);
                }}
              >
                <Select className="flex-shrink-0" showSearch>
                  {moes}
                </Select>
              </Form.Item>
            </Col>
            <Col className="flex-grow flex-shrink-0">
              <Form.Item
                name="parameter"
                label="Parameter"
                rules={[{ required: true }]}
              >
                <Select className="flex-shrink-0">{attributes}</Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]}>
            <Col className="flex-grow flex-shrink-0">
              <Form.Item
                name="operation"
                label="Operation"
                rules={[{ required: true }]}
              >
                <Select>
                  <Option value=">">{`>`}</Option>
                  <Option value="<">{`<`}</Option>
                  <Option value="=">{`=`}</Option>
                  <Option value="!=">{`!=`}</Option>
                  <Option value="between">between</Option>
                </Select>
              </Form.Item>
            </Col>

            <Col className="flex-grow flex-shrink-0">
              <Form.Item
                name="value"
                label="Value"
                rules={[{ required: true }]}
                dependencies={["operation"]}
              >
                {operation === "between" ||
                (!changed && data.operation === "between") ? (
                  <Input.Group compact>
                    <Form.Item
                      name={["value", "start"]}
                      noStyle
                      rules={[
                        { required: true, message: "Province is required" },
                      ]}
                    >
                      <InputNumber
                        className="w-1/2"
                        placeholder="0"
                        autosize={false}
                      />
                    </Form.Item>
                    <Form.Item
                      name={["value", "end"]}
                      noStyle
                      rules={[
                        { required: true, message: "Province is required" },
                      ]}
                    >
                      <InputNumber
                        className="w-1/2"
                        placeholder="500"
                        autosize={false}
                      />
                    </Form.Item>
                  </Input.Group>
                ) : (
                  <Input placeholder="500" />
                )}
              </Form.Item>
            </Col>
          </Row>

          <Form.Item name="type" label="Type" rules={[{ required: true }]}>
            <Select>
              <Option value="info">Info</Option>
              <Option value="warning">Warning</Option>
              <Option value="danger">Danger</Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default CreateAlert;
